
"use strict";

var React = require('react');
var Picture = require('../elements/Picture');
var Immutable = require('immutable');
var EMPTY_MAP = Immutable.Map();


class ProgramListTeasers extends React.Component {
	render() {
		var { model, ...other} = this.props;
		if(!model || model.isEmpty()) {
			return false;
		}

		return (
			<section {...other} className="svtse_program-list-teasers">
				<h1 className="svtse_program-list-teasers__heading">Rekommenderat</h1>
				<div className="svtse_grid">
				{model.toArray().map( function(item){
					return (
						<div className="svtse_grid__col-halves-thirds-sixths--small-medium" key={item.get('id')}>
							<a className="svtse_program-list-teasers__link" href={item.get('targetUrl')}>
								<Picture model={item.get('cover', EMPTY_MAP ).toJS()} type="small" />
								<div className="svtse_program-list-teasers__title">{item.get('title')}</div>
							</a>
						</div>
					);
				})}
				</div>
			</section>
		);
	}
}

module.exports = ProgramListTeasers;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramListTeasers.jsx
 **/